export default "__VITE_ASSET__C5qME6Z2__"